export default {
    Personal: 'home',
    Other: 'envelope',
    Work: 'building'
}
